import { GetAdminUserResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches one account's admin detail (GET /v1/admin/users/:id). Disabled until the
 * id is a valid positive number so a bad route param never fires a request. Gated
 * server-side by AdminGuard; a missing id returns 404.
 */
export const useAdminUser = (id: number) => {
	return useQuery<GetAdminUserResponse>({
		queryKey: queryKeys.adminUser(id),
		queryFn: async () => {
			const response = await api.get<GetAdminUserResponse>(`/admin/users/${id}`)
			return response.data
		},
		enabled: Number.isFinite(id) && id > 0,
	})
}
